import React from 'react';
import Grid from '@material-ui/core/Grid';
import MUISwitch from './Styled/Switch';
import Typography from '@material-ui/core/Typography';
import SwitchLabel from './Styled/SwitchLabel';

class Switch extends React.Component {
  handleSwitchChange = (evt, checked) => {
    const { afterChange, index, name, onChange } = this.props;
    if (typeof afterChange === 'function') {
      afterChange(checked, name, index);
    }
    onChange(evt, checked);
  };

  render() {
    const { disabled, label, name, value } = this.props;

    return (
      <Typography component="div">
        <Grid container alignItems="center" spacing={1}>
          <SwitchLabel item xs={12}>{label}</SwitchLabel>
          <Grid item>
            <MUISwitch
              disabled={disabled}
              checked={value}
              name={name}
              onChange={this.handleSwitchChange}
            />
          </Grid>
        </Grid>
      </Typography>
    );
  }
}

export default Switch;
